"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.errors.stepsLoadFailed': 'Nie udało się załadować kroków',
    'tutorial.errors.avatarsLoadFailed': 'Nie udało się załadować awatarów',
    'tutorial.errors.companiesLoadFailed': 'Nie udało się załadować firm',
    'tutorial.errors.loadFailed': 'Nie udało się załadować poradnika',
};
